const contextsMixin = (Base = class Empty {}) => class extends Base {

	injectContexts(contexts) {
		this.contexts = contexts;
	}

};

export default contextsMixin;
